require("preact-cli/lib/lib/webpack/polyfills");
require("./polyfills");
import 'webrtc-adapter';

import * as Sentry from '@sentry/browser';
import habitat from "preact-habitat";

import FCManager from "./manager";
import Widget from "./components/app";

const _habitat = habitat(Widget);

window.fcsdk = {};
window.fcsdk.init = function(apiKey, selector, user, options) {
  _habitat.render({
    selector,
    clean: true,
    defaultProps: {
      apiKey,
      user,
      options
    }
  });
};
window.fcsdk.openChannel = FCManager.openChannel.bind(FCManager);
window.fcsdk.openDirectConversation = FCManager.openDirectConversation.bind(FCManager);
window.fcsdk.openVideoCall = FCManager.openVideoCall.bind(FCManager);

if (process.env.PREACT_APP_NODE_ENV === "production")
  Sentry.init({ dsn: 'https://d5673edc3070463081f0da2a2545365d@sentry.io/5184644' });



// WEBPACK FOOTER //
// ./index.js